<template>
  <nav class="nav">
    <ul class="nav-menu">
      <router-link 
        v-for="(item, index) in navList" 
        :key="index" 
        :to="item.path">
        <li class="nav-menu-item">
          {{item.text}}
        </li>
      </router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    navList: Array
  }
}
</script>
<style scoped>
.nav-menu-item {
  color: #666;
}
.nav-menu-item {
  float: left;
  font-size: 20px;
  font-weight: bolder;
  line-height: 60px;
  margin-left: 40px;
  cursor: pointer;
  transition: all .2s ease-in;
}
.nav-menu-item:hover,
.router-link-exact-active .nav-menu-item{
  color: #fff;
}
</style>